export const NoResult = () => {
    return (
        <div className="text-center pt-4 pb-4">
            <i className="bx bx-search-alt fs-24 text-muted" />
            <h5 className="mt-2 text-muted">No Result Found</h5>
        </div>
    )
}